import { useQuery } from "@tanstack/react-query";
import { useUser as useClerkUser } from "@clerk/react";
import { api } from "@/lib/api";
import type { User } from "@/types";

export function useUserProfile() {
  const { user: clerkUser, isLoaded, isSignedIn } = useClerkUser();

  const query = useQuery({
    queryKey: ["user", clerkUser?.id],
    queryFn: async () => {
      if (!clerkUser?.id) throw new Error("No user ID");
      const response = await api.get<{ success: boolean; user: User }>(
        `/users/${clerkUser.id}`,
      );
      return response;
    },
    enabled: isLoaded && isSignedIn && !!clerkUser?.id,
    staleTime: 1000 * 60 * 5,
  });

  return {
    ...query,
    user: query.data?.user ?? null,
    clerkUser,
    isLoaded,
    isSignedIn,
    userId: clerkUser?.id ?? null,
  };
}
